"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectorTreeViewId = void 0;
var _selectors = require("../../utils/selectors");
const selectorTreeViewIdState = state => state.id;

/**
 * Get the id attribute of the tree view.
 * @param {TreeViewState<[UseTreeViewIdSignature]>} state The state of the tree view.
 * @returns {string} The id attribute of the tree view.
 */
const selectorTreeViewId = exports.selectorTreeViewId = (0, _selectors.createSelector)(selectorTreeViewIdState, idState => idState.treeId);